// SIZES
export const SMALL_SIZE = 'small';
export const REGULAR_SIZE = 'regular';
export const LARGE_SIZE = 'large';
export const SIZES = [SMALL_SIZE, REGULAR_SIZE, LARGE_SIZE];
